module.exports = __webpack_public_path__ + "img/vip-bg.7c559a67.png";